module.exports = __webpack_public_path__ + "static/media/rajat.f29fdb04.jpeg";